



























































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import dialogViewVenta from '@/components/dialogViewVenta.vue'
import HTTP from '@/plugins/axios'
import moment from 'moment'
moment.locale('es-MX')

@Component ({
  components: {
    dialogViewVenta
  }
})
export default class ViewReportesTienda extends Vue {
  private name: string = 'ViewReportesTienda'
  private search: string = ''
  private menu1: boolean = false
  private date = new Date().toISOString().substr(0, 10)
  private infoVenta: object = {}
  private tableVenta: any[] = []
  private tableBoletos: any[] = []
  private metodoPagoSelected: string = ''
  private metodoPago: any[] = [
    {
      text: 'Ninguno',
      id: ''
    },
    {
      text: 'OXXO CASH',
      id: 'oxxo_cash'
    },
    {
      text: 'Tarjeta Credito/Debito',
      id: 'card'
    },
    {
      text: 'NA (No Aplica / No Pago)',
      id: 'NA'
    }
  ]
  private optSelected: number = 0

  private fechaBusqueda: any = null

  private headers: any[] = [
    {
      text: 'Fecha',
      align: 'left',
      sortable: true,
      value: 'createdAt'
    },
    { text: 'Comprador', value: 'buyerName' },
    { text: 'Boletos', value: 'boleto' },
    { text: 'Metodo de Pago', value: 'paymentMethod' },
    { text: 'Monto', value: 'amountTotal' },
    { text: 'Acciones', value: 'acciones' }
  ]

  private headersBoleto: any[] = [
    {
      text: 'Fecha',
      align: 'left',
      sortable: true,
      value: 'createdAt'
    },
    { text: 'Folio', value: 'folio' },
    { text: 'Folio Encriptado', value: 'folioEncrypted' },
    { text: 'Tipo', value: 'boleto.name' },
    { text: 'Metodo de Pago', value: 'venta.paymentMethod' },
    { text: 'Acciones', value: 'acciones' }
  ]

  private showInfoVenta (item: any) {
    console.log('showInfoVenta :: ', item)
    this.gShowOrder(item.idOrder)
    this.infoVenta = Object.assign({}, item)
  }

  private get tVentas () {
    let res: any[] = []
    if ((this.metodoPagoSelected === '') && (this.search === '') && (this.fechaBusqueda === null)) {
      res = this.tableVenta
    } else {
      this.tableVenta.forEach((venta) => {
        if (
          (venta.buyerName.toUpperCase().search(this.search.toUpperCase()) >= 0 && this.search !== '') ||
          (venta.paymentMethod === this.metodoPagoSelected && this.metodoPagoSelected !== '') ||
          (moment(venta.createdAt).format('YYYY-MM-DD') === moment(this.fechaBusqueda).format('YYYY-MM-DD') && this.fechaBusqueda !== '')
        ) {
          res.push(venta)
        }
      })
    }
    console.log('res :: ', res)
    return res
  }

  private gShowOrder (id: string) {
    console.log('gShowOrder :: ')
    if (id === 'NO-CONEKTA') {
      return false
    }

    HTTP.get('conekta/' + id + '/find')
      .then((response) => {
        console.log('gShowOrder :: response :: ', response.data)
      })
      .catch((e) => {
        console.log('gShowOrder :: catch :: ', e.response.data)
      })
  }

  private resendEmail (item: any) {
    console.log('gShowOrder :: ')
    HTTP.get('conekta/' + item.id + '/resend-email')
      .then((response) => {
        console.log('gShowOrder :: response :: ', response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: 'El email ha sido, re-enviado.',
          color: 'success',
          show: true,
          timeout: 2000
        })
      })
      .catch((e) => {
        console.log('gShowOrder :: catch :: ', e.response.data)
      })
  }

  private viewPDF (item: any) {
    console.log('gShowOrder :: ')
    HTTP.get('conekta/' + item.id + '/view-pdf')
      .then((response) => {
        console.log('gShowOrder :: response :: ', response.data)
        window.open(process.env.VUE_APP_AXIOS_BASE_URL + 'conekta/pdf/' + response.data, '_blank')
      })
      .catch((e) => {
        console.log('gShowOrder :: catch :: ', e.response.data)
      })
  }

  private gShowAllVentas () {
    console.log('gShowAllVentas :: ')
    HTTP.get('venta/')
      .then((response) => {
        console.log('gShowAllVentas :: response :: ', response.data)
        this.tableVenta = response.data
      })
      .catch((e) => {
        console.log('gShowAllRol :: catch :: ', e.response.data)
      })
  }

  private gShowAllBoletos () {
    console.log('gShowAllBoletos :: ')
    HTTP.get('vendido/')
      .then((response) => {
        console.log('gShowAllBoletos :: response :: ', response.data)
        this.tableBoletos = response.data
      })
      .catch((e) => {
        console.log('gShowAllBoletos :: catch :: ', e.response.data)
      })
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    this.gShowAllVentas ()
    this.gShowAllBoletos()
  }
}
